<template>
    <footer>
        <div class="footer box">
            <div class="end-nav">
                <p>联系地址：浙江省杭州市余杭区仓前街道景兴路999号8幢404-3室 联系电话：0571-85196087</p>
                <p>Copyright © 2024-2025 杭州启帆数字技术有限公司 版权所有</p>
                <p>
                    ICP备案：
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">浙ICP备2025150593号-1</a>
                </p>
                <p></p>
            </div>
            <div style="width: 300px; margin: 0 auto; padding: 20px 0">
                <a
                    target="_blank"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002017173"
                    style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px"
                >
                    <!-- <img src="../../assets/images/备案图标.png" style="float: left" /> -->
                    <!-- <p style="float: left; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #939393">浙公网安备 33011002017173号</p> -->
                </a>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    props: {
        //msg: String
    },
    data: function () {
        return {};
    }
};
</script>
